<template>
  <v-container>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap align-center v-if="loader.loading == false">
        <v-flex xs12 sm8 md5>
          <v-card>
            <div class="pa-3 text-xs-center">
              <v-avatar to="/profile" :size="200"
                ><v-img
                  :src="this.$store.state.userSelf.profile.avatar"
                  :alt="
                    this.$store.state.userSelf.profile.firstname +
                    ' ' +
                    this.$store.state.userSelf.profile.lastname
                  "
                ></v-img
              ></v-avatar>
            </div>
            <hr />
            <v-card-title primary-title>
              <div>
                <h2>Change Your Profile Image</h2>
                <br />
                <div class="pl-4">
                  Note:- Only JPEG, JPG, PNG and GIF files are allowed. <br />
                  Please enable the toggle button, if you want to set the
                  uploaded image as your profile image.
                  <br />
                  <br />
                  <v-form
                    v-on:submit.prevent="fileUpload"
                    enctype="multipart/form-data"
                  >
                    &nbsp;&nbsp;<input
                      type="file"
                      @change="onFileSelected"
                      ref="fileInput"
                    />
                    <br />
                    <br />
                    <v-btn color="success" type="submit" :disabled="!FormValid"
                      >Upload Profile Image</v-btn
                    >
                  </v-form>
                </div>
                <br />
                <br />
                <div class="switch-div">
                  <label class="switch">
                    <input
                      type="radio"
                      name="profileImage"
                      v-model="profileImage"
                      v-bind:value="1"
                      :checked="profileImage == 1"
                    />
                    <span class="slider round"></span>
                  </label>
                </div>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <v-flex xs12 sm8 md1></v-flex>
        <v-flex xs12 sm8 md5>
          <v-card>
            <div class="pa-3 text-xs-center">
              <v-avatar to="/profile" :size="200"
                ><v-img
                  :src="this.$store.state.userSelf.profile.avatarlocal"
                  :alt="
                    this.$store.state.userSelf.profile.firstname +
                    ' ' +
                    this.$store.state.userSelf.profile.lastname
                  "
                ></v-img
              ></v-avatar>
            </div>
            <hr />
            <v-card-title primary-title>
              <div>
                <h2>Change Your Profile Image</h2>
                <br />
                <div class="pl-4">
                  If you joined using your email address you can change your
                  profile picture by creating an account with the same email
                  address ({{ $store.state.userSelf.profile.email }}) on
                  <a
                    href="https://en.gravatar.com/emails/"
                    target="_blank"
                    style="text-decoration: none"
                    >Gravitar.com <v-icon :size="18">mdi-open-in-new</v-icon></a
                  ><br />
                  <br />
                  If you joined using a Google account, you'll need to change
                  your profile picture on your
                  <a
                    href="https://myaccount.google.com/personal-info"
                    target="_blank"
                    style="text-decoration: none"
                    >Google Account
                    <v-icon :size="18">mdi-open-in-new</v-icon></a
                  >
                  <br />
                </div>
              </div>
              <br />
              <br />
              <div class="switch-div">
                <label class="switch">
                  <input
                    type="radio"
                    name="profileImage"
                    v-model="profileImage"
                    v-bind:value="0"
                    :checked="profileImage == 0"
                    @click="changeAvatar"
                    @chang="checkAvatar"
                  />
                  <span class="slider round"></span>
                </label>
              </div>
            </v-card-title>
          </v-card>
        </v-flex>
        <Popup :config="config"></Popup>
        <Confirm :config="config"></Confirm>
      </v-layout>
      <v-layout v-else>
        <v-flex>
          <v-dialog v-model="loader.loading" overlay persistent width="300">
            <Loader :config="loader"></Loader>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>
<script>
import Popup from "@/components/Popup";
import Confirm from "@/components/Confirm";
import Loader from "@/components/Loader";
import axios from "axios";

export default {
  components: {
    Popup,
    Confirm,
    Loader,
  },
  data() {
    return {
      FormValid: false,
      config: {
        dialog: false,
        title: "Alert",
        body: "Uploaded file is not a valid image. Only JPEG, JPG, PNG and GIF files are allowed and maximum size of image is 4mb.",
        footer: "Okay",
        confirm: false,
        confirmTitle: "Alert",
        confirmBody:
          "Are you sure, you want to fetch your profile image from  Gravitar.com and Google account.",
        confirmResult: 0,
      },
      loader: {
        loading: false,
      },
      file: "",
      profileImage: 0,
      userProfileImage: "",
    };
  },
  methods: {
    changeImage(result) {
      //console.log(result);
    },
    checkAvatar() {
      //console.log(this.profileImage);
    },
    changeAvatar() {
      if (this.profileImage) {
        this.config.confirm = true;
      }
    },
    onFileSelected(event) {
      if (event.target.files.length < 1) {
        this.FormValid = false;
      } else {
        console.log(event.target.files[0]);
        this.file = event.target.files[0];
        const fileType = this.file.type;
        const fileSize = this.file.size;
        console.log(fileType);
        const validImageTypes = [
          "image/gif",
          "image/jpeg",
          "image/png",
          "image/jpg",
        ];
        //console.log(this.profileImage);
        if (!validImageTypes.includes(fileType) || fileSize > 4000000) {
          this.FormValid = false;
          this.config.dialog = true;
        } else {
          this.FormValid = true;
        }
      }
    },
    fileUpload() {
      const formData = new FormData();
      var profileImageData = true;
      if (!this.profileImage) {
        this.config.body =
          "Please enable the toggle button, if you want to set the uploaded image as your profile image.";
        this.config.dialog = true;
      } else {
        if (this.profileImage) {
          profileImageData = true;
        } else {
          profileImageData = false;
        }
        this.loader.loading = true;
        formData.set("isavatarlocal", profileImageData);
        formData.append("file", this.file);
        const header = this.$store.state.axiosConfig;
        header.headers["content-type"] = "multipart/form-data";
        axios
          // Get the activity stream
          .post(
            "/api/user/profileimage",
            formData,
            this.$store.state.axiosConfig
          )
          .then((response) => {
            this.loader.loading = false;
            this.config.confirmResult = 0;
            this.$store.commit("replaceSnackbar", {
              message: "Profile image change successfully.",
              messageType: "success",
            });
            console.log(response);
            this.$store.state.userSelf.profile.isavatarlocal = true;
            this.$store.state.userSelf.profile.avatar =
              response.data.avatarlocal;
          })
          .catch((e) => {
            this.loader.loading = false;
            // check/ handle 401 (Unauthorized) error
            this.$store.dispatch("error401Response", e);

            // Display error message
            // ** Must set each property individually (ie can't set snackabar={prop:val, prop2:val2} or warnings happen)
            console.log("error");
            console.log(e);
          });
        header.headers["content-type"] = "application/json";
      }
    },
    changeAvatarImage() {
      this.loader.loading = true;
      const param = {
        isavatarlocal: false,
      };
      axios
        // Get the activity stream
        .post("/api/user/profileimage", param, this.$store.state.axiosConfig)
        .then((response) => {
          this.loader.loading = false;
          this.config.confirmResult = 0;
          this.$store.commit("replaceSnackbar", {
            message: "Profile image change successfully.",
            messageType: "success",
          });
          this.$store.state.userSelf.profile.isavatarlocal = false;
          this.$store.state.userSelf.profile.avatar =
            this.$store.state.userSelf.profile.avatarlocal;
        })
        .catch((e) => {
          this.loader.loading = false;
          this.config.confirmResult = 0;
          // check/ handle 401 (Unauthorized) error
          this.$store.dispatch("error401Response", e);

          // Display error message
          // ** Must set each property individually (ie can't set snackabar={prop:val, prop2:val2} or warnings happen)
          console.log("error");
          console.log(e);
        });
    },
  },
  beforeMount() {
    if (this.$store.state.userSelf.profile.isavatarlocal == true) {
      this.profileImage = 1;
    }
  },
  watch: {
    "config.confirmResult": {
      handler: function (after, before) {
        console.log(after);
        if (after == 1) {
          console.log("Gaurav");
          this.changeAvatarImage();
          this.profileImage = 0;
        }
      },
    },
  },
};
</script>
